import React, { useState, useEffect } from "react";
import { fire } from "../../firebase/config";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGlobe } from "@fortawesome/free-solid-svg-icons";
import { Container, Row, Col } from "react-bootstrap";
import Item from "../../Components/Item";
import RangeSlider from "../../Components/RangeSlider";
import Nanogram from "nanogram.js";
import FB from "fb";
import { Link } from "react-router-dom";

// FB.setAccessToken('EAAEDQ9ZAG7t8BAID1TdYHWZAEfN5aIdpLfEgfgyH2Jas6oc1G1ZA5Du6Wat2FP6HOZBh4zJuLsa14Osw406OT2edvEYurCVbJdyBxFpw7TCIvmxZBBXFmmNOtJ8W4uWzpqo6Q9JZAnGNuR9L5RDQkTF7cOpifUNLYSikwzQCAtZCbOOfl4QhCxZC9Nf7WC7f6ZC7XZCdsSSvm4j7ta464q8bGHQ5u1OLlJBiIt3jlWrv4VUgTu6UQLz5OA0BYkibl6tI0ZD')

function Section1() {
  const [followers, setFollowers] = useState([
    ["min", 1],
    ["max", 1000000],
  ]);
  const [amount, setAmount] = useState([
    ["min", 1],
    ["max", 1000000],
  ]);
  const [price, setPrice] = useState([
    ["min", 1],
    ["max", 1000000],
  ]);
  const [typeButton, setTypeButton] = useState(false);
  const [wayButton, setWayButton] = useState(false);
  const [db, setDb] = useState(null);
  const [filteredDb, setFilteredDb] = useState([]);
  const [categorySelected, setCategorySelected] = useState(null);
  const [waySelected, setWaySelected] = useState(null);
  useEffect(() => {
    fire
      .database()
      .ref("/ad")
      .once("value")
      .then((snapshot) => {
        setDb(snapshot.val());
      });
  }, []);

  const findByProperties = () => {
    let newDb = [];
    let propsList = [
      ["price", price],
      ["amount", amount],
      ["followers", followers],
    ];

    let allCheckCount = 0;
    propsList.map((i) => {
      if (i[1]) {
        allCheckCount = allCheckCount + i[1].length;
      }
    });

    db.map((elem) => {
      let checkCount = 0;

      propsList.map((item, index) => {
        if (item[1]) {
          item[1].map((method, index) => {
            if (method[0] === "max") {
              if (Number(elem[item[0]]) < Number(item[1][index][1])) {
                checkCount++;
              }
            }

            if (method[0] === "min") {
              if (Number(elem[item[0]]) > Number(item[1][index][1])) {
                checkCount++;
              }
            }
          });
        }
      });
      console.log(checkCount, allCheckCount);
      if (checkCount == allCheckCount) {
        if (categorySelected || waySelected) {
          if (categorySelected && !waySelected) {
            if (elem.category === categorySelected) {
              newDb.push(elem);
              setFilteredDb(newDb);
              console.log(newDb);
              return;
            }
          
          }
          if(!categorySelected && waySelected){
            if (elem.selectedTransmissionMethod === waySelected) {
              newDb.push(elem);
              setFilteredDb(newDb);
              console.log(newDb);
              return;
            }
          }
          if(!categorySelected && waySelected){
            if (elem.selectedTransmissionMethod === waySelected) {
              newDb.push(elem);
              setFilteredDb(newDb);
              console.log(newDb);
              return;
            }
          }
        }
        newDb.push(elem);
        setFilteredDb(newDb);
        console.log(newDb);
        return;
      }
      return;
    });
  };

  return (
    <div>
      <section class="price" id="price">
        <Container>
          <div class="price__wrapper">
            <Row>
              <div class="col-lg-9 m-auto col-10">
                <div class="price__items d-flex">
                  <div class="price-item__count item-count">
                    <div class="item-count__box">
                      <div class="item-count__subs">Подписчики</div>
                      <div class="mall-property">
                        <RangeSlider
                          changeCount={setFollowers}
                          presentValue={followers}
                        />

                        <input
                          data-min="price"
                          class="paso"
                          name="price-min"
                          onChange={(e) => {
                            let tmp = followers[1][1];
                            setFollowers([
                              ["min", e.target.value],
                              ["max", tmp],
                            ]);
                          }}
                          value={followers[0][1]}
                        />
                        <input
                          data-max="price"
                          class="paso1"
                          name="price-max"
                          onChange={(e) => {
                            let tmp = followers[0][1];
                            setFollowers([
                              ["min", tmp],
                              ["max", e.target.value],
                            ]);
                          }}
                          value={followers[1][1]}
                        />
                      </div>
                    </div>
                  </div>
                  <div class="price-item__count item-count">
                    <div class="item-count__box">
                      <div class="item-count__subs">Доход</div>
                      <div class="mall-property">
                        <RangeSlider
                          changeCount={setAmount}
                          presentValue={amount}
                        />

                        <input
                          data-min="price"
                          class="paso"
                          name="price-min"
                          onChange={(e) => {
                            let tmp = amount[1][1];
                            setAmount([
                              ["min", e.target.value],
                              ["max", tmp],
                            ]);
                          }}
                          value={amount[0][1]}
                        />
                        <input
                          data-max="price"
                          class="paso1"
                          name="price-max"
                          onChange={(e) => {
                            let tmp = amount[0][1];
                            setAmount([
                              ["min", tmp],
                              ["max", e.target.value],
                            ]);
                          }}
                          value={amount[1][1]}
                        />
                      </div>
                    </div>
                  </div>
                  <div class="price-item__count item-count">
                    <div class="item-count__box">
                      <div class="item-count__subs">Цена</div>
                      <div class="mall-property">
                        <RangeSlider
                          changeCount={setPrice}
                          presentValue={price}
                        />

                        <input
                          data-min="price"
                          class="paso"
                          id="paso"
                          name="price-min"
                          onChange={(e) => {
                            let tmp = price[1][1];
                            setPrice([
                              ["min", e.target.value],
                              ["max", tmp],
                            ]);
                          }}
                          value={price[0][1]}
                        />
                        <input
                          data-max="price"
                          class="paso1"
                          name="price-max"
                          onChange={(e) => {
                            let tmp = price[0][1];
                            setPrice([
                              ["min", tmp],
                              ["max", e.target.value],
                            ]);
                          }}
                          value={price[1][1]}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="price__search d-flex">
                  <div class="price-search__item search-item">
                    <div class="search-item__title">Тематика</div>

                    <div class="dropdown">
                      <button
                        class={
                          typeButton
                            ? "search-item__vp11 drop-active"
                            : "search-item__vp11"
                        }
                        onClick={() => {
                          setTypeButton(() => {
                            return !typeButton;
                          });
                        }}
                      >
                        Бизнес
                        <div class="dropdown-child">
                          <a
                            onClick={() => {
                              setCategorySelected("Подраздел 1");
                            }}
                          >
                            Подраздел 1
                          </a>
                          <a
                            onClick={() => {
                              setCategorySelected("Подраздел 2");
                            }}
                          >
                            Подраздел 2
                          </a>
                          <a
                            onClick={() => {
                              setCategorySelected("Подраздел 3");
                            }}
                          >
                            Подраздел 3
                          </a>
                          <a
                            onClick={() => {
                              setCategorySelected("Подраздел 4");
                            }}
                          >
                            Подраздел 4
                          </a>
                          <a
                            onClick={() => {
                              setCategorySelected("Подраздел 5");
                            }}
                          >
                            Подраздел 5
                          </a>
                        </div>
                      </button>
                    </div>
                  </div>
                  <div class="price-search__item search-item">
                    <div class="search-item__title">Способ передачи</div>
                    <div class="dropdown vp1">
                      <button
                        class={
                          wayButton
                            ? "search-item__vp1 vp1 block"
                            : "search-item__vp1 vp1"
                        }
                        onClick={() => {
                          setWayButton(() => {
                            return !wayButton;
                          });
                        }}
                      >
                        Права владельца
                        <div class="dropdown-child vpchild">
                          <a
                            onClick={() => {
                              setWaySelected("Подраздел 1");
                            }}
                          >
                            Подраздел 1
                          </a>
                          <a
                            onClick={() => {
                              setWaySelected("Подраздел 2");
                            }}
                          >
                            Подраздел 2
                          </a>
                          <a
                            onClick={() => {
                              setWaySelected("Подраздел 3");
                            }}
                          >
                            Подраздел 3
                          </a>
                          <a
                            onClick={() => {
                              setWaySelected("Подраздел 4");
                            }}
                          >
                            Подраздел 4
                          </a>
                          <a
                            onClick={() => {
                              setWaySelected("Подраздел 5");
                            }}
                          >
                            Подраздел 5
                          </a>
                        </div>
                      </button>
                    </div>
                  </div>
                  <div class="price-search__item search-item">
                    <form action="#" class="price__form">
                      <input class="search-item3__search" placeholder="Поиск" />
                    </form>
                    <div class="search-item3__subf">
                      <a href="#" class="search-item3__subf_item">
                        Сбросить фильтр
                      </a>
                    </div>
                  </div>
                </div>
                <div class="price-search__item search-item price-sort d-flex">
                  <div class="price-sort__title">Сортировать</div>
                  <div class="price-sort__items d-flex">
                    <div class="price-sort__item">
                      По Актуальности
                      <div class="price-sort-item__up"></div>
                      <div class="price-sort-item__down"></div>
                    </div>
                    <div class="price-sort__item">
                      По цене
                      <div class="price-sort-item__up"></div>
                      <div class="price-sort-item__down"></div>
                    </div>
                    <div class="price-sort__item">
                      По Подписчикам
                      <div class="price-sort-item__up"></div>
                      <div class="price-sort-item__down"></div>
                    </div>
                    <div class="price-sort__item">
                      По Доходу
                      <div class="price-sort-item__up"></div>
                      <div class="price-sort-item__down"></div>
                    </div>
                  </div>
                </div>
                <div class="price-search__item search-item sm d-flex ml-auto">
                  <div class="sm__item psi1">
                    <a href="#">
                      <i class="fas fa-globe"></i>
                    </a>
                  </div>
                  <div class="sm__item psi2">
                    <a href="#">
                      <i class="fab fa-tiktok"></i>
                    </a>
                  </div>
                  <div class="sm__item psi3">
                    <a href="#">
                      <i class="fab fa-youtube"></i>
                    </a>
                  </div>
                  <div class="sm__item psi4">
                    <a href="#">
                      <i class="fab fa-vk"></i>
                    </a>
                  </div>
                  <div class="sm__item psi5">
                    <a href="#">
                      <i class="fab fa-instagram"></i>
                    </a>
                  </div>
                  <div class="sm__item psi6">
                    <a href="#">
                      <i class="fab fa-facebook-f"></i>{" "}
                    </a>
                  </div>
                  <div class="sm__item psi7">
                    <a href="#">
                      <i class="fab fa-odnoklassniki"></i>
                    </a>
                  </div>
                  <div class="sm__item psi8">
                    <a href="#">
                      <i class="fab fa-telegram-plane"></i>
                    </a>
                  </div>
                </div>
                <button onClick={findByProperties}>Search</button>
              </div>
            </Row>
          </div>
        </Container>
      </section>
      {db ? (
        <section class="sec" id="sec">
          <Container>
            <Row>
              <div class="col-lg-9 m-auto col-10">
                {db.map((item, index) => {
                  if (index % 3 === 0 || index === 0) {
                    if (!db[index + 2] && db[index + 1]) {
                      console.log(!db[index + 2]);
                      return (
                        <div class="sec__items d-flex">
                          <Link to={`/ad/${index}`}>
                            <Item item={db[index]} />
                          </Link>
                          <Link to={`/ad/${index + 1}`}>
                            <Item item={db[index]} />
                          </Link>
                          <div></div>
                        </div>
                      );
                    }
                    if (!db[index + 1]) {
                      console.log("1");
                      return (
                        <div class="sec__items d-flex">
                          <Link to={`/ad/${index}`}>
                            <Item item={db[index]} />
                          </Link>
                        </div>
                      );
                    }
                    return (
                      <div>
                        <div class="sec__items d-flex">
                          <Link to={`/ad/${index}`}>
                            <Item item={db[index]} />
                          </Link>
                          <Link to={`/ad/${index}`}>
                            <Item item={db[index + 1]} />
                          </Link>
                          <Link to={`/ad/${index}`}>
                            <Item item={db[index + 2]} />
                          </Link>
                        </div>
                        {index === 0 ? (
                          <div class="sec__bs sec-bs d-flex">
                            <div class="sec-bs__title">
                              <div class="sec-bs__subtitle">
                                Оформляй покупку групп через
                              </div>
                              <div class="sec-bs__title">Безопасную сделку</div>
                              <div class="sec-bs__more">
                                <a href="#">Подробнее</a>
                              </div>
                            </div>
                            <div class="sec-bs__img">
                              <img src="img/zamok.svg" alt="custle" />
                            </div>
                          </div>
                        ) : null}
                      </div>
                    );
                  }
                  return;
                })}

                <div class="sec__btn d-flex">
                  <a href="#">Показать еще</a>
                </div>
              </div>
            </Row>
          </Container>
        </section>
      ) : null}
    </div>
  );
}

export default Section1;
